import ready from './ready';
import { getRadar, getResultRadar, showResultsRadar } from './radar';
import { getScore, getScoreArray, addToScore } from './scores';

let scrollTimeout = 0;

function gtmScreenEvent(screen) {
	let screenName = '';
	window.dataLayer = window.dataLayer || [];
	if (screen.dataset.order) {
		screenName = 'Q' + screen.dataset.order;
	} else {
		screenName = 'Summary results';
	}

	window.dataLayer.push({
		event: 'show_screen',
		screenName: screenName,
	});
}

/**
 * Gets the list element containing the quiz 'navigation'
 *
 * @returns {HTMLElement}
 */
function getList() {
	return document.querySelector('.quiz__list-radar ol');
}

function getAllScreens() {
	return document.querySelectorAll('.screen[data-order]');
}

/**
 * Scroll smoothly to the top of the page - mainly useful
 * on mobile, but also somewhat useful on desktop
 */
function toTop() {
	// a short delay to allow the aniamtion to happen and
	// in case of a race condition where the scroll is attempted
	// when the previous and next screens are both hidden
	window.clearTimeout(scrollTimeout);
	scrollTimeout = window.setTimeout(() => {
		try {
			window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
		} catch (error) {
			window.scrollTo(0, 0);
		}
	}, 100);
}

function observerCallback(mutationArray) {
	mutationArray.forEach((mutation) => {
		const { status, order } = mutation.target.dataset;
		const list = getList();
		const radar = getRadar();
		list.querySelector(`[data-order="${order}"]`).dataset.status = status;
		radar.querySelector(`[data-order="${order}"]`).dataset.status = status;
	});
}

function resetQuestion(question) {
	const radios = question.querySelectorAll('input[type="radio"]');
	Array.prototype.forEach.call(radios, (el) => {
		el.checked = false;
	});

	const ranges = question.querySelectorAll('input[type="range"]');
	Array.prototype.forEach.call(ranges, (el) => {
		el.value = '0';
		// dispatch the event so that the slider updates
		const event = new Event('input');
		el.dispatchEvent(event);
	});
}

// rest all questions
function onResetButton() {
	const screens = document.querySelectorAll('.screen');
	// Reset all form values
	Array.prototype.forEach.call(screens, resetQuestion);

	// navigate to the first q
	for (let i = 0, j = screens.length; i < j; i++) {
		let answeredStatus = 'unanswered';
		if (i === 0) {
			answeredStatus = 'active';
		}

		screens[i].dataset.status = answeredStatus;
	}
}

// navigate backwards using buttons
function onBackButton(event) {
	const button = event.currentTarget;
	const screen = button.closest('.screen');
	const screenPrev = screen.previousElementSibling;

	screen.dataset.status = 'unanswered';
	screenPrev.dataset.status = 'active';

	toTop();
	event.preventDefault();
}

function clearScoreExplanations() {
	const explanations = document.querySelectorAll('.-score-dependent');
	Array.prototype.forEach.call(explanations, (el) => {
		el.style.display = 'none';
	});
}

// Navigate forwards using submit buttons
function onSubmit(event) {
	if (!event.target.matches('.question__form')) {
		return;
	}

	const form = event.target;
	const screen = event.target.closest('.screen');
	const screenNext = screen.nextElementSibling;

	screen.dataset.status = 'answered';
	screenNext.dataset.status = 'active';
	gtmScreenEvent(screenNext);
	toTop();

	if (form.matches('[data-order] form')) {
		const formdata = new FormData(form);
		const scoreArray = getScoreArray();
		const type = formdata.get('questiontype');
		let answerid = null;

		if (type === 'multi') {
			let checked = form.querySelector('input[type="radio"]:checked');
			answerid = checked.dataset.answerid;
		}

		addToScore(scoreArray, {
			answerid,
			type,
			answer: formdata.get('answer'),
			order: screen.dataset.order,
			weighting: form.dataset.weighting,
		});

		document.getElementById('score').innerText = getScore(scoreArray);
	}

	// Given the score, show the relevant explanation
	if (event.target.matches('.-last-question')) {
		clearScoreExplanations();
		let score = getScore(getScoreArray());
		let scoreSelector = '';
		const scoreBoundaries = [20, 40, 60, 80, 101];
		for (const boundary of scoreBoundaries) {
			if (score < boundary) {
				scoreSelector = '.-score-under-' + boundary;
				break;
			}
		}
		// Reveal the appropriate score explanation
		const scoreFeedback = document.querySelectorAll(scoreSelector);
		Array.prototype.forEach.call(scoreFeedback, (el) => {
			el.style.display = 'block';
		});

		// display the result radar
		showResultsRadar(getResultRadar(), getScoreArray());
	}

	event.preventDefault();
}

ready.then(() => {
	// Back buttons listener
	const backbuttons = document.querySelectorAll('button.back-button');
	Array.prototype.forEach.call(backbuttons, (el) => {
		el.addEventListener('click', onBackButton);
	});

	// Back to start button
	// This triggers the reset.bouygues event.
	//document
	//	.querySelector('button.reset-button')
	//	.addEventListener('click', () => {
	//		const resetEvent = new CustomEvent('reset.bouygues');
	//		document.body.dispatchEvent(resetEvent);
	//	});

	document.body.addEventListener('reset.bouygues', onResetButton);

	// Progress forwards through the questions
	document.body.addEventListener('submit', onSubmit);

	// Linking the questions to the list on the right
	const screens = getAllScreens();
	const observer = new MutationObserver(observerCallback);

	Array.prototype.forEach.call(screens, (el) => {
		observer.observe(el, {
			attributes: true,
			attributeFilter: ['data-status'],
		});
	});
});
